import { Mutations } from 'vuex-smart-module';
import { Videos } from '../types';
import VideosState from './state';

export default class VideosMutations extends Mutations<VideosState> {
  SET_VIDEOS(videos: Videos.Video[]) {
    this.state.videos = videos;
  }
}
